import { Endpoint, Rest } from 'aurelia-api';
import { DialogController } from 'aurelia-dialog';
import { autoinject, inject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { ControllerValidateResult, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { SchoolClassViewModel } from '../../models/schoolclassview-model';
import { StudentCreateViewModel } from '../../models/studentcreateview-model';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { Helpers } from '../../services/helpers';

@autoinject
export class StudentModalCreate {
    private logger: Logger = LogManager.getLogger('STUDENTMODALCREATE');
    private validationController: ValidationController;
    private model: StudentCreateViewModel;
    private classes: SchoolClassViewModel[] = [];
    private saveDisabled: boolean = false;
    public classId: number | null = null;

    constructor(
        @inject(Endpoint.of('api'))
        private api: Rest,
        private dialog: DialogController,
        private validationControllerFactory: ValidationControllerFactory) {

        this.validationController = validationControllerFactory.createForCurrentScope();
        this.validationController.addRenderer(new BootstrapFormRenderer());

        this.getModel();
    }

    async getModel() {
        this.logger.debug('getModel');
        this.model = new StudentCreateViewModel();
    }

    async activate(params: any) {
        this.logger.debug('activate');

        // optional
		if (params && params.classId) {
			this.classId = params.classId;
		}

        await this.getSchoolClasses();
    }

    async getSchoolClasses() {
        this.logger.debug('getSchoolClasses');

        await this.api.find('/SchoolClass/GetAll')
            .then((data: Array<SchoolClassViewModel>) => {
                this.classes = data;

                // set the classId if it's provided
                if (this.classId) {
                    this.model.schoolClassId = this.classId;
                }

                this.logger.debug('Success getSchoolClasses');
            }).catch(async (err) => {
                this.logger.debug('Error getSchoolClasses: ', err);
                await Helpers.ParseValidationError(err, this.validationController, this.model);
            });
    }

    cancel() {
        this.logger.debug('cancel');
        this.dialog.cancel();
    }

    async save() {
        this.logger.debug('save');
        this.saveDisabled = true;

		const validation: ControllerValidateResult = await this.validationController.validate();

        if (validation.valid) {
            await this.api.post('/Student/Insert', this.model)
                .then(async (data: any) => {
                    this.logger.debug('Success save: ', data);
                    this.saveDisabled = false;
					// close dialog
                    await this.dialog.ok(data);
                }).catch(async (err) => {
                    this.logger.debug('Error save: ', err);
                    await Helpers.ParseValidationError(err, this.validationController, this.model);
                    this.saveDisabled = false;
                });
        } else {
            this.saveDisabled = false;
        }
    }
}